import InputNode from 'src/viewLayer/components/nodes/InputNode';
import QuestionNode from 'src/viewLayer/components/nodes/QuestionNode';
import { PageNode } from 'src/viewLayer/components/nodes/PageNode';
import { RedirectNode } from 'src/viewLayer/components/nodes/RedirectNode';

export default {
  QuestionNode,
  InputNode,
  PageNode,
  RedirectNode
};
